import React from 'react';
import '../myutils';
import { translate } from 'react-admin';
import Typography from '@material-ui/core/Typography';

export default translate(({ variant, translate, text, locale }) => (
    <Typography variant={variant} align={(locale==='he'||locale==='yi')?"right":"left"} style={(locale==='he'||locale==='yi')?{direction:'rtl'}:{direction:'ltr'}}>
            {translate(text)}
    </Typography>
));
